<template>
  <div>
    <div class="loader-desktop">
      <ContentLoader
        :height="44"
        :speed="1"
        primary-color="#f3f3f3"
        secondary-color="#ecebeb"
      >
        <rect x="140" y="0" rx="4" ry="4" width="120" height="12" />
        <rect x="120" y="24" rx="4" ry="4" width="150" height="15" />
      </ContentLoader>

      <div class="bill-card__data">
        <div class="bill-card__data-item">
          <ContentLoader
            :speed="1"
            primary-color="#f3f3f3"
            secondary-color="#ecebeb"
          >
            <rect x="0" y="0" rx="3" ry="3" width="250" height="34" />
            <rect x="0" y="54" rx="3" ry="3" width="180" height="32" />
          </ContentLoader>
        </div>

        <div class="bill-card__data-item">
          <ContentLoader
            :speed="1"
            primary-color="#f3f3f3"
            secondary-color="#ecebeb"
          >
            <rect x="70" y="0" rx="3" ry="3" width="260" height="34" />
            <rect x="110" y="54" rx="3" ry="3" width="180" height="32" />
          </ContentLoader>
        </div>

        <div class="bill-card__data-item">
          <ContentLoader
            :speed="1"
            primary-color="#f3f3f3"
            secondary-color="#ecebeb"
          >
            <rect x="150" y="0" rx="3" ry="3" width="250" height="34" />
            <rect x="220" y="54" rx="3" ry="3" width="180" height="32" />
          </ContentLoader>
        </div>
      </div>

      <ContentLoader
        :speed="1"
        :height="36"
        primary-color="#f3f3f3"
        secondary-color="#ecebeb"
      >
        <rect x="0" y="0" rx="4" ry="4" width="400" height="36" />
      </ContentLoader>
    </div>

    <div class="loader-tablet">
      <ContentLoader
        :height="130"
        :speed="1"
        primary-color="#f3f3f3"
        secondary-color="#ecebeb"
      >
        <rect x="157" y="0" rx="4" ry="4" width="86" height="8" />
        <rect x="145" y="18" rx="4" ry="4" width="110" height="9" />
        <rect x="0" y="46" rx="4" ry="4" width="90" height="8" />
        <rect x="0" y="62" rx="4" ry="4" width="100" height="8" />
        <rect x="0" y="78" rx="4" ry="4" width="80" height="8" />
        <rect x="0" y="104" rx="4" ry="4" width="400" height="26" />
      </ContentLoader>
    </div>

    <div class="loader-mobile">
      <ContentLoader
        :height="300"
        :speed="1"
        primary-color="#f3f3f3"
        secondary-color="#ecebeb"
      >
        <rect x="100" y="0" rx="4" ry="4" width="200" height="18" />
        <rect x="60" y="40" rx="4" ry="4" width="260" height="24" />
        <rect x="0" y="104" rx="4" ry="4" width="210" height="20" />
        <rect x="0" y="140" rx="4" ry="4" width="230" height="20" />
        <rect x="0" y="180" rx="4" ry="4" width="200" height="20" />
        <rect x="0" y="240" rx="4" ry="4" width="400" height="60" />
      </ContentLoader>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.bill-card__data {
  display: flex;
  height: 108px;
  justify-content: space-between;
}

.bill-card__data-item {
  display: flex;
  justify-content: center;

  svg {
    width: 100%;
  }
}

.loader-mobile {
  @media (min-width: $screen-xs-min) {
    display: none;
  }
}

.loader-tablet {
  display: none;

  @media (max-width: $screen-sm-max) and (min-width: $screen-xs-min) {
    display: block;
  }
}

.loader-desktop {
  display: none;

  @media (min-width: $screen-md-min) {
    display: block;
  }
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
